
/**
 * SEO 配置 - models (Polski)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Generator wideo AI zgodny z fizyką | WeryAI',
        description: 'Generuj realistyczne filmy AI zgodne z prawami fizyki za pomocą OpenAI Sora 2 ze zsynchronizowanym dźwiękiem i spójnością narracji.',
        keywords: 'Sora 2, OpenAI Sora, model wideo AI, realistyczne wideo AI, tekst na wideo, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Natywny Generator Obrazów AI | WeryAI',
        description: 'Użyj WeryAI Image 2 do oszałamiającego natywnego generowania obrazów AI! Model flagowy z zaawansowaną kontrolą stylu. Darmowe kredyty, bez karty.',
        keywords: 'WeryAI Image 2, natywny generator obrazów AI, obraz AI flagowy, jakość studyjna AI, WeryAI Image za darmo, jak używać WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Bezpłatny Grok 2 - Generator Obrazów xAI | WeryAI',
        description: 'Użyj Grok 2 na WeryAI do generowania kreatywnych obrazów AI! Model xAI z artystyczną elastycznością. Darmowe kredyty, bez karty.',
        keywords: 'Grok 2, Grok AI, generator obrazów xAI, sztuka AI, kreatywne obrazy AI, Grok 2 za darmo, jak używać Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Generator Obrazów | WeryAI',
        description: 'Nano Banana 2 napędzany przez Gemini z wiedzą o świecie i wyszukiwaniem w czasie rzeczywistym. Generuj faktycznie dokładne, oszałamiające obrazy z ultra-szybką prędkością.',
        keywords: 'Nano Banana 2, Google AI, Gemini, generowanie obrazów, renderowanie tekstu, spójność wielu obiektów, 4K, WeryAI',
        og_title: 'Generator obrazów Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 jest zasilany przez Gemini z głębokim zrozumieniem świata i wyszukiwaniem w czasie rzeczywistym, generując obrazy piękne i faktycznie dokładne.',
        twitter_title: 'Generator obrazów Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 jest zasilany przez Gemini z głębokim zrozumieniem świata i wyszukiwaniem w czasie rzeczywistym, generując obrazy piękne i faktycznie dokładne.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Generator obrazów AI Nano Banana 2',
        twitterImageAlt: 'Generator obrazów AI Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Kinowy generator wideo AI | WeryAI',
        description: 'Kling 2.5 Turbo tworzy kinowe filmy AI wysokiej jakości z zaawansowaną kontrolą obiektywu, ekspresją emocjonalną i płynną fizyką ruchu.',
        keywords: 'Kling 2.5 Turbo, Kling AI, kinowe wideo AI, kontrola obiektywu AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 Zaawansowany generator i edytor wideo | WeryAI',
        description: 'Runway Gen-4 generuje realistyczne i spójne filmy AI z głębszym zrozumieniem promptów i inteligentnymi narzędziami do edycji. Wypróbuj za darmo na WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, generator wideo AI, tekst na wideo, obraz na wideo, edycja wideo AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Generator wideo AI Hailuo zaawansowane tworzenie | WeryAI',
        description: 'Generuj zaawansowane filmy AI za pomocą Hailuo AI w WeryAI. Najnowocześniejsza kontrola ruchu i realistyczne renderowanie scen.',
        keywords: 'Hailuo AI, MiniMax, generator wideo AI, kontrola ruchu, realistyczne wideo, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Generator wideo Seedance AI Tworzenie tańca i ruchu | WeryAI',
        description: 'Generator wideo Seedance AI - Tworzenie tańca i ruchu on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Generator Wideo AI Poziomu Reżysera | WeryAI',

        description: 'Twórz wideo AI poziomu reżysera z Werydance 2.0: multimodalne odniesienia, spójność narracji i symulacja fizyki. Za darmo na WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, generator wideo AI, wideo reżyserskie, wideo multimodalne, symulacja fizyki, synchronizacja ust, tekst na wideo, darmowe wideo AI, WeryAI',

        og_title: 'Werydance 2.0 - Generator Wideo AI Poziomu Reżysera | WeryAI',

        og_description: 'Twórz wideo AI poziomu reżysera z Werydance 2.0: multimodalne odniesienia, spójność narracji i symulacja fizyki. Za darmo na WeryAI.',

        twitter_title: 'Werydance 2.0 - Generator Wideo AI Poziomu Reżysera | WeryAI',

        twitter_description: 'Twórz wideo AI poziomu reżysera z Werydance 2.0: multimodalne odniesienia, spójność narracji i symulacja fizyki. Za darmo na WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Bezpłatny Nano Banana Pro - Generator Obrazów AI | WeryAI',
        description: 'Użyj Nano Banana Pro na WeryAI do obrazów AI najwyższej wierności! Rywalizuje z Midjourney w jakości. Darmowe kredyty, bez karty.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google obraz AI, obraz AI rozumowania, 4K obraz AI, Nano Banana Pro za darmo, jak używać Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Bezpłatny Nano Banana - Generator Obrazów AI | WeryAI',
        description: 'Użyj Nano Banana na WeryAI do łatwego tworzenia obrazów AI! Wszechstronny i szybki model AI. Darmowe kredyty, bez karty.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google obraz AI, szybki generator AI, spójność postaci, Nano Banana za darmo, jak używać Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Bezpłatny FLUX - Wypróbuj Generator Obrazów AI | WeryAI',
        description: 'Użyj FLUX na WeryAI do generowania niesamowitych obrazów AI! Stworzony przez zespół Stable Diffusion z wyjątkową jakością wizualną. Darmowe kredyty, bez karty.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, generator obrazów AI, tekst na obraz, sztuka AI, FLUX za darmo, jak używać FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Bezpłatny FLUX Kontext - Pro Edytor Obrazów AI | WeryAI',
        description: 'Użyj FLUX Kontext na WeryAI do profesjonalnej edycji obrazów AI! Doskonała dokładność, zaawansowana typografia i edycja wieloetapowa. Darmowe kredyty, bez karty.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, edytor obrazów AI, profesjonalne obrazy AI, typografia AI, FLUX Kontext za darmo, jak używać FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Bezpłatny Imagen 4 - Google Generator Obrazów AI | WeryAI',
        description: 'Użyj Google Imagen 4 na WeryAI do tworzenia fotorealistycznych obrazów AI! Wszechstronna kontrola stylów i precyzyjne generowanie tekstu. Darmowe kredyty, bez karty.',
        keywords: 'Imagen 4, Google Imagen, generator obrazów AI Google, tekst na obraz, fotorealistyczna AI, Imagen za darmo, jak używać Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Bezpłatny Qwen Image - Model Obrazów AI Alibaba | WeryAI',
        description: 'Użyj Qwen Image na WeryAI do generowania wielojęzycznej sztuki AI! Model open-source Alibaba z doskonałym renderowaniem tekstu. Darmowe kredyty, bez karty.',
        keywords: 'Qwen Image, Alibaba AI, obraz AI open-source, wielojęzyczne renderowanie tekstu, Qwen Image za darmo, jak używać Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Bezpłatny Wan AI - Generator Obrazów Alibaba | WeryAI',
        description: 'Użyj Wan AI na WeryAI do obrazów AI wysokiej wierności! Model Alibaba z precyzyjnym śledzeniem podpowiedzi i fotorealistycznym renderowaniem. Darmowe kredyty, bez karty.',
        keywords: 'Wan AI, Wan 2.5, generator obrazów AI Alibaba, tekst na obraz, fotorealistyczna AI, Wan AI za darmo, jak używać Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Bezpłatny Seedream 4.0 - ByteDance Obraz AI | WeryAI',
        description: 'Użyj Seedream 4.0 na WeryAI do ultraszybkiego generowania obrazów AI! Model ByteDance z różnorodnymi stylami artystycznymi. Darmowe kredyty, bez karty.',
        keywords: 'Seedream, Seedream 4.0, ByteDance obraz AI, ultraszybki obraz AI, style artystyczne AI, Seedream za darmo, jak używać Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Bezpłatny Dreamina 4.0 - Multimodalny Obraz AI | WeryAI',
        description: 'Użyj Dreamina 4.0 na WeryAI do multimodalnego tworzenia obrazów AI! Szkic na obraz, transfer stylu i fuzja postaci. Darmowe kredyty, bez karty.',
        keywords: 'Dreamina 4.0, ByteDance obraz AI, multimodalny obraz AI, szkic na obraz, transfer stylu, Dreamina za darmo, jak używać Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Bezpłatny Seedream 4.5 - ByteDance Obraz AI | WeryAI',
        description: 'Użyj Seedream 4.5 na WeryAI do flagowego generowania obrazów AI! Najnowszy ByteDance z precyzyjną typografią. Darmowe kredyty, bez karty.',
        keywords: 'Seedream 4.5, ByteDance obraz AI, model flagowy, renderowanie typografii, fuzja wielu obrazów, Seedream 4.5 za darmo, jak używać Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Najlepszy Model Generacji Obrazów AI | WeryAI',
        description: 'Seedream 5.0 to arcydzieło ByteDance w dziedzinie wizualnej AI z natywną jakością 8K, ostatecznym zrozumieniem semantycznym, kompozycją wielopodmiotową i renderowaniem tekstu 2.0. Wypróbuj za darmo na WeryAI.',
        keywords: 'Seedream 5.0, generacja obrazów AI, jakość 8K, zrozumienie semantyczne, kompozycja wielopodmiotowa, renderowanie tekstu, ByteDance, WeryAI',
        og_title: 'Generator Obrazów Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 to arcydzieło ByteDance w generacji wizualnej AI z natywną jakością 8K, ostatecznym zrozumieniem semantycznym, kompozycją wielopodmiotową i zaawansowanym renderowaniem tekstu.',
        twitter_title: 'Generator Obrazów Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 to arcydzieło ByteDance w generacji wizualnej AI z natywną jakością 8K, ostatecznym zrozumieniem semantycznym, kompozycją wielopodmiotową i zaawansowanym renderowaniem tekstu.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Generator obrazów AI Seedream 5.0',
        twitterImageAlt: 'Generator obrazów AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Profesjonalny Generator Grafiki Wektorowej AI | WeryAI',
        description: 'Recraft V4 Vector to profesjonalny generator grafiki wektorowej AI od Recraft.ai, generujący edytowalne wektory SVG z bezstratnym skalowaniem, precyzyjną typografią i kontrolą stylu marki. Wypróbuj za darmo na WeryAI teraz.',
        keywords: 'Recraft V4 Vector, generacja wektorów AI, generator SVG, prawdziwy wektor, projekt logo, ikony UI, ilustracja wektorowa, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Bezpłatny Midjourney - Generator Sztuki AI | WeryAI',
        description: 'Użyj Midjourney na WeryAI do tworzenia artystycznych obrazów AI! Znany z oszałamiającej estetyki i jakości oświetlenia. Darmowe kredyty, bez karty.',
        keywords: 'Midjourney, Midjourney AI, generator sztuki AI, artystyczne obrazy AI, Midjourney za darmo, alternatywa Midjourney, jak używać Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generator Wideo AI | WeryAI',
        description: 'Twórz niesamowite filmy z Runway Gen-4.5 na WeryAI. Hybrydowa architektura autoregresyjno-dyfuzyjna dla precyzyjnej symulacji fizyki i spójności czasowej.',
        keywords: 'Runway Gen-4.5, generator wideo AI, kinowe wideo AI, symulacja fizyki, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generator Wideo AI | WeryAI',
        description: 'Generuj wysokiej jakości filmy z Kling 2.6 Pro na WeryAI. Natywna generacja audiowizualna, kinowa jakość 1080p, doskonałe przestrzeganie podpowiedzi.',
        keywords: 'Kling 2.6 Pro, generator wideo AI, wysokiej jakości wideo AI, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generator Wideo Precyzyjna kontrola | WeryAI',
        description: 'Generuj kinowe filmy AI z Dreamina 3.0 (Jimeng 3.0) na WeryAI. Precyzyjna kontrola klatek początkowych/końcowych, profesjonalne ruchy kamery i generowanie wideo 1080p o wysokiej dynamice.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generator wideo AI, kontrola kamery, klatki początkowe końcowe, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generator Wideo AI Kreatywna Generacja | WeryAI',
        description: 'Uwolnij swoją kreatywność na WeryAI z generatorem wideo AI Kling O1. Idealny do tworzenia pomysłowej i unikalnej zawartości wideo.',
        keywords: 'Kling O1, generator wideo AI, kreatywne wideo AI, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Inteligentny Generator Wideo AI | WeryAI',

        description: 'Twórz wideo AI z Kling 3.0: inteligentny storyboard, wielojęzyczna synchronizacja ust i precyzyjne renderowanie tekstu. Za darmo na WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, generator wideo AI, inteligentny storyboard, synchronizacja ust, renderowanie tekstu, tekst na wideo, obraz na wideo, darmowe wideo AI, WeryAI',

        og_title: 'Kling 3.0 - Inteligentny Generator Wideo AI | WeryAI',

        og_description: 'Twórz wideo AI z Kling 3.0: inteligentny storyboard, wielojęzyczna synchronizacja ust i precyzyjne renderowanie tekstu. Za darmo na WeryAI.',

        twitter_title: 'Kling 3.0 - Inteligentny Generator Wideo AI | WeryAI',

        twitter_description: 'Twórz wideo AI z Kling 3.0: inteligentny storyboard, wielojęzyczna synchronizacja ust i precyzyjne renderowanie tekstu. Za darmo na WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Natywny 16s Audio-Wideo AI | WeryAI',

        description: 'Generuj natywne 16-sekundowe audio-wideo z Vidu Q3: inteligentny montaż, precyzyjne renderowanie tekstu i wielojęzyczny lip-sync. Za darmo na WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, generator wideo AI, natywne 16s audio-wideo, inteligentny storyboard, renderowanie tekstu, synchronizacja ust, tekst na wideo, obraz na wideo, darmowe wideo AI, WeryAI',

        og_title: 'Vidu Q3 - Natywny 16s Audio-Wideo AI | WeryAI',

        og_description: 'Generuj natywne 16-sekundowe audio-wideo z Vidu Q3: inteligentny montaż, precyzyjne renderowanie tekstu i wielojęzyczny lip-sync. Za darmo na WeryAI.',

        twitter_title: 'Vidu Q3 - Natywny 16s Audio-Wideo AI | WeryAI',

        twitter_description: 'Generuj natywne 16-sekundowe audio-wideo z Vidu Q3: inteligentny montaż, precyzyjne renderowanie tekstu i wielojęzyczny lip-sync. Za darmo na WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Bezpłatny GPT-4o - Generator Obrazów OpenAI | WeryAI',
        description: 'Użyj GPT-4o na WeryAI do tworzenia obrazów przez rozmowę! AI OpenAI z precyzyjnym renderowaniem tekstu. Darmowe kredyty, bez karty.',
        keywords: 'GPT-4o, GPT-4o obraz, generator obrazów OpenAI, konwersacyjna sztuka AI, GPT-4o za darmo, jak używać GPT-4o obrazy, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Bezpłatny GPT Image 1.5 - Generator Sztuki OpenAI | WeryAI',
        description: 'Użyj GPT Image 1.5 na WeryAI do sztuki AI nowej generacji! Najnowszy model OpenAI z ulepszoną kreatywnością. Darmowe kredyty, bez karty.',
        keywords: 'GPT Image 1.5, model obrazu OpenAI, generator sztuki AI, AI nowej generacji, GPT Image 1.5 za darmo, jak używać GPT Image 1.5, WeryAI',
    },
}
